import { ChangeDetectionStrategy, Component, HostListener, inject, signal } from '@angular/core';
import { ToolsBoxService } from '../../Services/tools.service';
import { NgClass } from '@angular/common';
import { RouterLink } from '@angular/router';
import { TrigrammePipe } from '../../Pipes/trigramme.pipe';

@Component({
    selector: 'headerComponent',
    styleUrls: ['header.component.css'],
    templateUrl: 'header.component.html',
    imports: [NgClass, RouterLink, TrigrammePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderComponent {
    private readonly tools = inject(ToolsBoxService);

    readonly pageName   = this.tools.pageName;
    readonly userAvatar = this.tools.avatar;

    readonly userName: string = this.tools.getStoredUserLogin();
    readonly AvatarBackground: string = "user-first-initial-" + this.userName?.split('.')[1]?.charAt(0).toLowerCase();

    readonly showDropdown = signal(false);

    toggleDropdown(event: Event) {
      event.stopPropagation();
      this.showDropdown.update(v => !v);
    }

    @HostListener('document:click')
    closeDropdown() {
      this.showDropdown.set(false);
    }

    displayLogin(): string {
      return this.userName;
    }
}
